import type * as React from 'react';
import { ConfirmDialog } from '@verclam/ui-kit';

/**
 * A bare `<ConfirmDialog />` host — no `message`, no `visible` — which is exactly what makes it a
 * host rather than a declarative dialog: only an instance with neither prop subscribes to
 * `confirmDialog()` calls (`UsersConfirmationDialogs.tsx`). Without it, every impersonated call on
 * this screen is silently lost: `SpeakerAssignmentSidebar`'s removal and merge confirmations, and
 * T7's own unsaved-edit guard. One host serves the whole page; mounting a second one would emit a
 * development warning and still only the first-mounted would answer.
 *
 * Mounted by T9 (wave 3) alongside `InterviewDetails/index.tsx`, never by this file itself.
 */
const InterviewDetailsConfirmationDialogs: React.FC = () => {
	return <ConfirmDialog />;
};

export default InterviewDetailsConfirmationDialogs;
